import React, { useEffect } from "react";
import {
  Hero,
  Services,
  Why,
  About,
  Reviews,
  MiniServices,
  Enquire,
} from "../../components";
import { servicesHome } from "../../data";
import PageMeta from "../../seo/PageMeta";
import { LOCAL_BUSINESS_SCHEMA } from "../../seo/localBusiness";

const Home = () => {
  useEffect(() => {
    window.scroll({ behavior: "smooth", top: 0 });
  }, []);
  return (
    <div className="flex flex-col items-center w-full">
      <PageMeta
        title="Clear Choice Cleaning Services | Cleaning Services in Melbourne, Australia"
        description="Professional cleaning and janitorial services in Melbourne, Australia by Clear Choice Cleaning Services. Get your free quote today."
        path="/"
        image="/assets/images/banners/cover.webp"
        jsonLd={[LOCAL_BUSINESS_SCHEMA]}
      />
      <Hero />
      <Services data={servicesHome} />
      <About />
      <Why />
      <Reviews />
      <Enquire />
      <MiniServices />
    </div>
  );
};

export default Home;
